module.exports = __webpack_public_path__ + "static/media/23_B.87d3d776.png";